import { ErrorBoundary } from '@sentry/react';
import type { ReactNode } from 'react';
import { Suspense } from 'react';

import { Skeleton } from '@/shared/ui';
import { withForm } from '@/shared/ui/form';

import { signalAlertFormOptions } from '../../model';
import { SignalAlertActionSection } from './signal-alert-action-section';
import { SignalAlertTriggerSection } from './signal-alert-trigger-section';
import { validateDuplicateTitle } from './signal-alert-utils';

export const SignalAlertFormPanel = withForm({
  ...signalAlertFormOptions,
  props: {
    workspaceId: '',
    renderFooter: undefined as (() => ReactNode) | undefined,
    existingTitles: new Set<string>(),
  },
  render: ({ form, workspaceId, renderFooter, existingTitles }) => {
    return (
      <div className="flex flex-col gap-5">
        {/* Details 섹션 */}
        <div className="flex flex-col gap-5 rounded-lg border p-5">
          <span className="text-sm font-semibold">Details</span>
          <div className="grid grid-cols-[100px_1fr] items-start gap-3">
            <span className="pt-2 text-sm text-muted-foreground">Title</span>
            <form.AppField
              name="title"
              validators={{
                onChange: ({ value }) => {
                  if (!value) return 'Please enter a title';
                  return validateDuplicateTitle(value, existingTitles);
                },
                onSubmit: ({ value }) => {
                  if (!value) return 'Please enter a title';
                  return validateDuplicateTitle(value, existingTitles);
                },
              }}
              children={(field) => (
                <field.TextField placeholder="Enter title..." />
              )}
            />
          </div>
        </div>

        <ErrorBoundary fallback={<></>}>
          <Suspense fallback={<Skeleton className="" />}>
            <SignalAlertTriggerSection form={form} workspaceId={workspaceId} />
          </Suspense>
        </ErrorBoundary>
        <SignalAlertActionSection form={form} workspaceId={workspaceId} />
        {renderFooter?.()}
      </div>
    );
  },
});
